import React, { useState } from "react";
import { Button, Modal, Input } from "antd";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import axios from "axios";
import { useCan } from "../../../utils/permissions";
const ChatInput = ({ tranId, onSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const cookies = new Cookies();
  const token = cookies.get("token");
  const can = useCan();
  const canCreateNote = can("note", "create");

  const showModal = () => setVisible(true);
  const handleCancel = () => {
    setVisible(false);
    setNote("");
  };

  const handleSend = async () => {
    if (!note.trim()) return toast.error("Note cannot be empty");

    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API}/note/create`,
        { tranId, note },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Note added");
      setNote("");
      setVisible(false);
      if (typeof onSuccess === "function") {
        onSuccess(); // ✅ trigger re-fetch in Index.jsx
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to add note");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal} disabled={!canCreateNote}>
        Create Note
      </Button>
      <Modal
        title="Add Message"
        open={visible}
        onCancel={handleCancel}
        onOk={handleSend}
        okText={loading ? "Sending..." : "Send"}
        confirmLoading={loading}
      >
        <Input.TextArea
          rows={4}
          placeholder="Enter message..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default ChatInput;

